import InfoCards from "@/components/common/InfoCards";
import { Box } from "@mui/system";
import { FC } from "react";

import SearchIcon from '@mui/icons-material/Search';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ShieldIcon from '@mui/icons-material/Shield';

const DocCards: FC = () => {
    return (
        <Box sx={{ px: { xs: 6, md: 8, lg: 10 } }}>
            <InfoCards
                layout="stacked"
                stackSpacing={{ xs: 2, sm: 2.5, md: 3 }}
                containerMargin={{ xs: 3, sm: 4, md: 6, lg: 8 }}
                cards={[{
                    icon: <SearchIcon />,
                    iconColor: 'secondary.main',
                    title: 'Buscar y Consultar',
                    content: "Encuentra documentos por nombre, categoría o fecha. Descarga manuales, formatos, certificados y planes académicos.",
                    useIconBox: true
                },
                {
                    icon: <SaveAltIcon />,
                    iconColor: 'primary.dark',
                    title: 'Gestionar Documentos',
                    content: "Sube archivos individuales o carpetas completas. Organiza por etiquetas y elimina carpetas con todo su contenido.",
                    useIconBox: true
                }, {
                    icon: <ShieldIcon />,
                    iconColor: 'primary.main',
                    title: 'Acceso Seguro',
                    content: "Cada usuario ve y gestiona únicamente los documentos autorizados para su rol.",
                    useIconBox: true
                },
                ]}
            />
        </Box>)
};

export default DocCards;